import React, { useState } from 'react';
import './Calendar.css';

function Calendar({ bookedDates = [], onSelectDates }) {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [checkIn, setCheckIn] = useState(null);
  const [checkOut, setCheckOut] = useState(null);

  const daysInMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1).getDay();

  const isDateBooked = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return bookedDates.includes(dateStr);
  };

  const isDateInRange = (date) => {
    if (!checkIn || !checkOut) return false;
    return date > checkIn && date < checkOut;
  };

  const handleDateClick = (day) => {
    const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    
    if (isDateBooked(date)) return;

    if (!checkIn) {
      setCheckIn(date);
    } else if (!checkOut) {
      if (date <= checkIn) {
        setCheckIn(date);
        setCheckOut(null);
      } else {
        setCheckOut(date);
        onSelectDates(checkIn, date);
      }
    } else {
      setCheckIn(date);
      setCheckOut(null);
    }
  };

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1));
  };

  const renderCalendar = () => {
    const days = [];
    const totalDays = daysInMonth(currentMonth);
    const firstDay = firstDayOfMonth(currentMonth);

    // Empty cells for days before the month starts
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-empty"></div>);
    }

    // Days of the month
    for (let day = 1; day <= totalDays; day++) {
      const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
      const dateStr = date.toISOString().split('T')[0];
      const booked = isDateBooked(date);
      const isCheckIn = checkIn && dateStr === checkIn.toISOString().split('T')[0];
      const isCheckOut = checkOut && dateStr === checkOut.toISOString().split('T')[0];
      const inRange = isDateInRange(date);
      const isPast = date < new Date(new Date().setHours(0, 0, 0, 0));

      days.push(
        <div
          key={day}
          className={`calendar-day ${booked ? 'booked' : ''} ${isCheckIn ? 'check-in' : ''} ${isCheckOut ? 'check-out' : ''} ${inRange ? 'in-range' : ''} ${isPast ? 'past' : ''}`}
          onClick={() => handleDateClick(day)}
        >
          {day}
        </div>
      );
    }

    return days;
  };

  const monthYear = currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={handlePrevMonth} className="calendar-nav">←</button>
        <h3>{monthYear}</h3>
        <button onClick={handleNextMonth} className="calendar-nav">→</button>
      </div>

      <div className="calendar-weekdays">
        <div>Sun</div>
        <div>Mon</div>
        <div>Tue</div>
        <div>Wed</div>
        <div>Thu</div>
        <div>Fri</div>
        <div>Sat</div>
      </div>

      <div className="calendar-grid">
        {renderCalendar()}
      </div>

      <div className="calendar-legend">
        <div className="legend-item">
          <span className="legend-color booked"></span> Booked
        </div>
        <div className="legend-item">
          <span className="legend-color selected"></span> Selected
        </div>
        <div className="legend-item">
          <span className="legend-color available"></span> Available
        </div>
      </div>

      {checkIn && (
        <div className="date-display">
          <span>Check-in: {checkIn.toLocaleDateString()}</span>
          {checkOut && <span>Check-out: {checkOut.toLocaleDateString()}</span>}
          {checkOut && (
            <span className="nights">
              {Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24))} nights
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default Calendar;
